import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { ToastContainer } from "react-toastify";
import { useLanguageTranslator } from "../../../components";
import { MinusIcon } from "../../../@lib/icons/minus";
import { PlusIcon } from "../../../@lib/icons/plus";
import { toastHandler } from "../../../utils/helpers";
import { toastTypesKeys } from "../../../utils/constants";

function CountryCategoryFilter({
  data = [],
  setFilterState,
  filtersState,
}: any) {
  const { translator } = useLanguageTranslator();

  const totalWeight = filtersState?.category?.reduce(
    (sum: any, item: any) => sum + (item.weight || 0),
    0
  );

  function handleIncrementPlusCategory(id: number) {
    const isWeightOne = Number(totalWeight) >= 100;

    if (isWeightOne) {
      toastHandler(
        `You are not allowed to select category weight greater than 100 percent`,
        toastTypesKeys.error
      );
      return;
    }

    setFilterState((prevFilters: any) => {
      const existing = prevFilters.category.find(
        (cat: any) => cat.categoryId === id
      );

      let updatedCategory;
      if (existing) {
        updatedCategory = prevFilters.category.map((cat: any) =>
          cat.categoryId === id ? { ...cat, weight: cat.weight + 1 } : cat
        );
      } else {
        updatedCategory = [
          ...prevFilters.category,
          { categoryId: id, weight: 1 },
        ];
      }

      return {
        ...prevFilters,
        category: updatedCategory,
      };
    });
  }

  function handleDecrementCategory(id: number) {
    setFilterState((prevFilters: any) => {
      const existing = prevFilters.category.find(
        (cat: any) => cat.categoryId === id
      );

      if (!existing) {
        return prevFilters;
      }

      const newWeight = existing.weight - 1;

      let updatedCategory;
      if (newWeight <= 0) {
        updatedCategory = prevFilters.category.filter(
          (cat: any) => cat.categoryId !== id
        );
      } else {
        updatedCategory = prevFilters.category.map((cat: any) =>
          cat.categoryId === id ? { ...cat, weight: newWeight } : cat
        );
      }

      return {
        ...prevFilters,
        category: updatedCategory,
      };
    });
  }

  //   const handleOnChange = (categoryId: number, newValue: number) => {
  //     const weight = newValue;

  //     setFilterState((prev: any) => {
  //       const updatedCategories = [...(prev?.category || [])];
  //       const index = updatedCategories.findIndex(
  //         (cat: any) => cat.categoryId === categoryId
  //       );

  //       if (!weight || weight <= 0) {
  //         if (index !== -1) {
  //           updatedCategories.splice(index, 1);
  //         }
  //       } else {
  //         if (index !== -1) {
  //           updatedCategories[index].weight = weight;
  //         } else {
  //           updatedCategories.push({ categoryId, weight: weight });
  //         }
  //       }

  //       return {
  //         ...prev,
  //         category: updatedCategories,
  //       };
  //     });
  //   };

  const handleOnChange = (categoryId: number, newValue: number | "") => {
    const weight = typeof newValue === "number" ? newValue : 0;

    setFilterState((prev: any) => {
      const updatedCategories = [...(prev?.category || [])];
      const index = updatedCategories.findIndex(
        (cat: any) => cat.categoryId === categoryId
      );

      // Calculate total weight excluding current category
      const totalWithoutCurrent = updatedCategories.reduce((sum, cat) => {
        if (cat.categoryId !== categoryId) {
          return sum + (cat.weight || 0);
        }
        return sum;
      }, 0);

      // If value is cleared or <= 0, remove category
      if (!weight || weight <= 0) {
        if (index !== -1) {
          updatedCategories.splice(index, 1);
        }
      } else {
        // Prevent if total + new weight exceeds 100
        if (totalWithoutCurrent + weight > 100) {
          toastHandler(
            `You are not allowed to select category weight greater than 100 percent`,
            toastTypesKeys.error
          );
          return prev; // Skip updating
        }

        if (index !== -1) {
          updatedCategories[index].weight = weight;
        } else {
          updatedCategories.push({ categoryId, weight });
        }
      }

      return {
        ...prev,
        category: updatedCategories,
      };
    });
  };
  
  return (
    <>
      <ToastContainer />
      <Stack direction="row" justifyContent="space-between" mb={2} mt={5}>
        <Typography variant="h6" component="h2">
          {translator(`Add value for each category`)}({totalWeight})
        </Typography>{" "}
        <Button
          sx={{
            backgroundColor: "#F6A000",
            borderRadius: "20px",
            color: "white",
            fontSize: "12px",
            height: "24px",
            "&:hover": {
              backgroundColor: "#D48B00",
            },
          }}
          onClick={() => {
            setFilterState((prevFilters: any) => {
              return {
                ...prevFilters,
                category: [],
              };
            });
          }}
        >
          {translator(`Clear`)}
        </Button>
      </Stack>
      <Box
        sx={{
          border: "1px solid",
          borderColor: "#EAEAEA",
          padding: "0px 20px",
          borderRadius: "10px",
          maxHeight: "30dvh",
          overflowY: "auto",
        }}
      >
        {data?.map((op: any, i: any) => {
          const isSelected = filtersState?.category?.some(
            (cat: any) => cat.categoryId === op.id
          );

          return (
            <Stack
              direction="row"
              my={2}
              justifyContent="space-between"
              key={`country-categories-${op?.id}`}
            >
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{
                  border: isSelected ? "2px solid" : "1px solid",
                  borderColor: isSelected ? "#F6A000" : "#EAEAEA",
                  padding: "5px 20px",
                  borderRadius: "20px",
                  width: "100%",
                  margin: "0px 10px",
                }}
              >
                {op.name}
              </Typography>{" "}
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems={"center"}
                sx={{
                  border: isSelected ? "2px solid" : "1px solid",
                  borderColor: isSelected ? "#F6A000" : "#EAEAEA",
                  padding: "5px 10px",
                  width: "170px",
                  borderRadius: "20px",
                }}
              >
                <span
                  style={{ cursor: "pointer" }}
                  onClick={
                    op?.value !== 0
                      ? () => handleDecrementCategory(op?.id)
                      : () => {}
                  }
                >
                  <MinusIcon dimension="10px" />
                </span>
                <TextField
                  type="number"
                  size="small"
                  value={
                    filtersState?.category?.find(
                      (cat: any) => cat.categoryId === op.id
                    )?.weight ?? ""
                  }
                  onChange={(e: any) => {
                    const val = Number(e.target.value);
                    if (val <= 100) {
                      handleOnChange(op?.id, Number(e.target.value));
                    }
                  }}
                  sx={{
                    width: 70,
                    padding: "0px",
                    fontSize: "10px",
                    "& .MuiInputBase-root": {
                      padding: "0px",
                      height: "30px",
                      fontSize: "15px",
                    },
                    "& .MuiInputBase-input": {
                      padding: "0px !important",
                      textAlign: "center",
                    },
                  }}
                />
                <span
                  style={{ cursor: "pointer" }}
                  onClick={
                    op.value !== 100
                      ? () => handleIncrementPlusCategory(op?.id)
                      : () => {}
                  }
                >
                  <PlusIcon dimension="10px" />
                </span>
              </Stack>
            </Stack>
          );
        })}
      </Box>
    </>
  );
}

export { CountryCategoryFilter };
